import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '@/assets/icons/chevron-right-gray.svg'


const _hoisted_1 = {
  key: 0,
  class: "admin-header"
}
const _hoisted_2 = { class: "buttons" }
const _hoisted_3 = {
  key: 0,
  class: "poi-card-image"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "poi-card-body" }
const _hoisted_6 = { class: "poi-card-title" }
const _hoisted_7 = {
  key: 0,
  class: "poi-card-desc"
}
const _hoisted_8 = {
  key: 0,
  class: "map-skeleton-overlay"
}
const _hoisted_9 = {
  key: 1,
  class: "status-legend"
}
const _hoisted_10 = { class: "legend-item" }
const _hoisted_11 = { class: "legend-item" }
const _hoisted_12 = { class: "legend-item" }
const _hoisted_13 = { class: "legend-item" }
const _hoisted_14 = { class: "legend-item" }
const _hoisted_15 = { class: "legend-item" }
const _hoisted_16 = { class: "legend-item" }
const _hoisted_17 = { class: "legend-item" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["viewBox"]
const _hoisted_20 = ["d"]
const _hoisted_21 = ["transform"]
const _hoisted_22 = ["x", "y", "width", "height", "href"]
const _hoisted_23 = ["x", "y", "font-size"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["d"]
const _hoisted_26 = ["transform"]
const _hoisted_27 = ["x", "y", "font-size"]
const _hoisted_28 = ["d"]
const _hoisted_29 = ["d", "onClick", "onMouseover", "onMouseleave"]
const _hoisted_30 = ["points", "onClick", "onMouseover", "onMouseleave"]
const _hoisted_31 = ["x", "y", "width", "height", "onClick", "onMouseover", "onMouseleave"]
const _hoisted_32 = ["d"]
const _hoisted_33 = ["x", "y", "transform", "font-size", "onClick", "onMouseover", "onMouseleave"]
const _hoisted_34 = ["x", "y", "transform", "font-size", "onClick", "onMouseover", "onMouseleave"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["x", "y", "width", "height"]
const _hoisted_37 = ["transform"]
const _hoisted_38 = ["transform"]
const _hoisted_39 = ["y", "font-size"]
const _hoisted_40 = { class: "skeleton-list" }
const _hoisted_41 = {
  key: 1,
  class: "side-panel-content"
}
const _hoisted_42 = { class: "side-panel-wrapper scroll-wrapper" }
const _hoisted_43 = { class: "stages-list" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "stage-card-body" }
const _hoisted_46 = { class: "stage-name" }
const _hoisted_47 = { class: "stage-meta" }
const _hoisted_48 = {
  key: 0,
  class: "no-lots-info-wr"
}
const _hoisted_49 = { class: "side-panel-title bold" }
const _hoisted_50 = { class: "stage-summary-meta" }
const _hoisted_51 = {
  key: 0,
  class: "land-subdivision-package-filter"
}
const _hoisted_52 = { class: "side-panel-wrapper scroll-wrapper" }
const _hoisted_53 = ["onMouseover", "onMouseleave", "onClick"]
const _hoisted_54 = { class: "land-subdivision-lot-card__main" }
const _hoisted_55 = { class: "land-subdivision-lot-card__header" }
const _hoisted_56 = { class: "land-subdivision-lot-card__details" }
const _hoisted_57 = { class: "land-subdivision-lot-card__detail" }
const _hoisted_58 = { class: "detail-value" }
const _hoisted_59 = { class: "land-subdivision-lot-card__detail" }
const _hoisted_60 = { class: "detail-value" }
const _hoisted_61 = { class: "land-subdivision-lot-card__detail land-subdivision-lot-card__detail--price" }
const _hoisted_62 = { class: "detail-value" }
const _hoisted_63 = {
  key: 0,
  class: "land-subdivision-lot-card__packages"
}
const _hoisted_64 = { class: "land-subdivision-lot-card__actions" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["onMouseover", "onMouseleave", "onClick"]
const _hoisted_68 = { class: "lot-card-main" }
const _hoisted_69 = { class: "lot-card-header" }
const _hoisted_70 = { class: "lot-card-title" }
const _hoisted_71 = {
  key: 0,
  class: "lot-card-subtitle"
}
const _hoisted_72 = {
  key: 0,
  class: "lot-design-name"
}
const _hoisted_73 = {
  key: 1,
  class: "lot-dot"
}
const _hoisted_74 = {
  key: 2,
  class: "lot-facade-name"
}
const _hoisted_75 = { class: "lot-card-details" }
const _hoisted_76 = { class: "lot-dimensions" }
const _hoisted_77 = {
  key: 0,
  class: "lot-detail-item"
}
const _hoisted_78 = {
  key: 1,
  class: "lot-detail-item"
}
const _hoisted_79 = {
  key: 0,
  class: "lot-detail-item lot-price-item"
}
const _hoisted_80 = { class: "lot-card-image" }
const _hoisted_81 = ["src", "alt"]
const _hoisted_82 = {
  key: 1,
  class: "lot-card-image-fallback"
}
const _hoisted_83 = { class: "lot-card-actions" }
const _hoisted_84 = ["onClick"]
const _hoisted_85 = ["onClick"]
const _hoisted_86 = {
  key: 2,
  class: "no-lots-info-wr"
}
const _hoisted_87 = { class: "lots-panel-header" }
const _hoisted_88 = { class: "selection-card" }
const _hoisted_89 = { class: "selection-card-inner" }
const _hoisted_90 = { class: "selection-card-text" }
const _hoisted_91 = { class: "selection-name" }
const _hoisted_92 = {
  key: 0,
  class: "selection-facade"
}
const _hoisted_93 = { class: "selection-price" }
const _hoisted_94 = { class: "selection-specs" }
const _hoisted_95 = { class: "selection-spec-item" }
const _hoisted_96 = { class: "selection-spec-item" }
const _hoisted_97 = { class: "selection-spec-item" }
const _hoisted_98 = { class: "selection-spec-item" }
const _hoisted_99 = ["src"]
const _hoisted_100 = { class: "side-panel-title bold" }
const _hoisted_101 = { class: "side-panel-wrapper scroll-wrapper" }
const _hoisted_102 = { class: "lots-list" }
const _hoisted_103 = ["onMouseover", "onMouseleave", "onClick"]
const _hoisted_104 = { class: "lot-card-main" }
const _hoisted_105 = { class: "lot-card-header" }
const _hoisted_106 = { class: "lot-card-title" }
const _hoisted_107 = {
  key: 0,
  class: "lot-card-subtitle"
}
const _hoisted_108 = {
  key: 1,
  class: "lot-card-subtitle"
}
const _hoisted_109 = { class: "lot-card-details" }
const _hoisted_110 = { class: "lot-dimensions" }
const _hoisted_111 = {
  key: 0,
  class: "lot-detail-item"
}
const _hoisted_112 = {
  key: 1,
  class: "lot-detail-item"
}
const _hoisted_113 = {
  key: 0,
  class: "lot-detail-item lot-price-item"
}
const _hoisted_114 = { class: "lot-card-image" }
const _hoisted_115 = ["src", "alt"]
const _hoisted_116 = {
  key: 1,
  class: "lot-card-image-fallback"
}
const _hoisted_117 = {
  key: 0,
  class: "no-lots-info-wr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["interactive-map-wr", { isBuilderView: $setup.props.builderView }])
  }, [
    ($setup.props.role === $setup.UserRoles.SUPER_ADMIN)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "title-main" }, "Interactive Masterplan", -1)),
          _createElementVNode("div", _hoisted_2, [
            (!$setup.masterplan)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button default primary add-btn-primary",
                  onClick: $setup.toCreateMasterplan
                }, "Add Masterplan"))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("button", {
                    class: "button default outlined",
                    onClick: $setup.toEditMasterplan
                  }, "Edit Masterplan"),
                  _createElementVNode("button", {
                    class: "button default outlined warning",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showConfirmDeleteModal = true))
                  }, "Delete Masterplan")
                ], 64))
          ]),
          _createVNode($setup["ConfirmDeleteModal"], {
            isOpen: $setup.showConfirmDeleteModal,
            deleteItem: 'interactive masterplan',
            onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.showConfirmDeleteModal = false)),
            onConfirm: $setup.deleteMasterplan
          }, null, 8, ["isOpen"])
        ]))
      : _createCommentVNode("", true),
    ($setup.selectedLot && $setup.isLandSubdivisionBuyerView)
      ? (_openBlock(), _createBlock($setup["LandSubdivisionLotDetailModal"], {
          key: 1,
          isOpen: $setup.showLotModal,
          lot: $setup.selectedLot,
          stage: $setup.selectedStage,
          lotPreviewUrl: $setup.lotPreviewUrl,
          onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.showLotModal = false)),
          onEnquiry: _cache[3] || (_cache[3] = ($event: any) => ($setup.showLotModal = false))
        }, null, 8, ["isOpen", "lot", "stage", "lotPreviewUrl"]))
      : ($setup.selectedLot)
        ? (_openBlock(), _createBlock($setup["LotDetailModal"], {
            key: 2,
            isOpen: $setup.showLotModal,
            lot: $setup.selectedLot,
            stage: $setup.selectedStage,
            stageLots: $setup.lotsForSelectedStage,
            preferredHouseDesignId: $setup.currentSidebarView === 'lot-matching' ? $props.matchingHouseDesignId : undefined,
            onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.showLotModal = false)),
            onSelect: $setup.onSelectLot,
            onEnquiry: _cache[5] || (_cache[5] = ($event: any) => ($setup.showLotModal = false))
          }, null, 8, ["isOpen", "lot", "stage", "stageLots", "preferredHouseDesignId"]))
        : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "poi-slide" }, {
      default: _withCtx(() => [
        ($setup.selectedPoi)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "poi-modal-backdrop",
              onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.selectedPoi = null))
            }, [
              _createElementVNode("div", {
                class: "poi-detail-card",
                onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("button", {
                  class: "poi-close-btn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.selectedPoi = null))
                }, "✕"),
                ($setup.selectedPoi.imageUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("img", {
                        src: $setup.selectedPoi.imageUrl,
                        alt: $setup.selectedPoi.title
                      }, null, 8, _hoisted_4)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h3", _hoisted_6, _toDisplayString($setup.selectedPoi.title), 1),
                  ($setup.selectedPoi.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString($setup.selectedPoi.description), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["svg-wrapper", { isBuilderView: $setup.props.builderView, isCustomerView: $setup.props.role === $setup.UserRoles.CUSTOMER, isEmbedded: $setup.props.isEmbedded, isMobileMapExpanded: $setup.mobileMapExpanded, isPhoneLandscape: $setup.isPhoneLandscape }]),
      ref: "mapWrapper"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["svg-container-map svg-map-with-sidebar", { isBuilderView: $setup.props.builderView }])
      }, [
        _createElementVNode("div", {
          class: "map-elements-container",
          style: _normalizeStyle($setup.masterplanCssVars)
        }, [
          ($setup.lotsLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["map-elements-wr", { isBuilderView: $setup.props.builderView }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["zoom-container", [{ 'zoom-active': $setup.zoom !== 1 && $setup.isDesktop && !$setup.isPhoneLandscape }, { 'zoom-hidden': $setup.props.builderView }]])
            }, [
              _createElementVNode("button", {
                class: "button zoom-btn",
                onClick: $setup.zoomIn
              }, "+"),
              _createElementVNode("button", {
                class: "button zoom-btn",
                onClick: $setup.zoomOut
              }, "-")
            ], 2),
            ($setup.props.role === $setup.UserRoles.CUSTOMER)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "mobile-expand-map-btn",
                  type: "button",
                  onClick: $setup.toggleMobileMap
                }, [
                  _createVNode($setup["Expand"], { size: 16 }),
                  _createElementVNode("span", null, _toDisplayString($setup.mobileMapExpanded ? "Collapse Map" : "Expand Map"), 1)
                ]))
              : _createCommentVNode("", true),
            ($setup.masterplan)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (!$setup.showLots)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", {
                            class: "legend-dot",
                            style: _normalizeStyle({ background: $setup.MASTERPLAN_STATUS_COLORS['success'].bg })
                          }, null, 4),
                          _cache[11] || (_cache[11] = _createElementVNode("span", null, "Now Selling", -1))
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", {
                            class: "legend-dot",
                            style: _normalizeStyle({ background: $setup.MASTERPLAN_STATUS_COLORS['warning'].bg })
                          }, null, 4),
                          _cache[12] || (_cache[12] = _createElementVNode("span", null, "Sold Out", -1))
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", {
                            class: "legend-dot",
                            style: _normalizeStyle({ background: $setup.MASTERPLAN_STATUS_COLORS['gray'].bg })
                          }, null, 4),
                          _cache[13] || (_cache[13] = _createElementVNode("span", null, "Not Released", -1))
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", {
                            class: "legend-dot",
                            style: _normalizeStyle({ background: $setup.MASTERPLAN_STATUS_COLORS['success'].bg })
                          }, null, 4),
                          _cache[14] || (_cache[14] = _createElementVNode("span", null, "Available", -1))
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", {
                            class: "legend-dot",
                            style: _normalizeStyle({ background: $setup.MASTERPLAN_STATUS_COLORS['light-blue'].bg })
                          }, null, 4),
                          _cache[15] || (_cache[15] = _createElementVNode("span", null, "On Hold", -1))
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", {
                            class: "legend-dot",
                            style: _normalizeStyle({ background: $setup.MASTERPLAN_STATUS_COLORS['yellow'].bg })
                          }, null, 4),
                          _cache[16] || (_cache[16] = _createElementVNode("span", null, "Reserved", -1))
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", {
                            class: "legend-dot",
                            style: _normalizeStyle({ background: $setup.MASTERPLAN_STATUS_COLORS['warning'].bg })
                          }, null, 4),
                          _cache[17] || (_cache[17] = _createElementVNode("span", null, "Sold", -1))
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", {
                            class: "legend-dot",
                            style: _normalizeStyle({ background: $setup.MASTERPLAN_STATUS_COLORS['gray'].bg })
                          }, null, 4),
                          _cache[18] || (_cache[18] = _createElementVNode("span", null, "Not Released", -1))
                        ])
                      ], 64))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["scroll-wrapper map-scroll-wrapper", { 'svg-container grab': $setup.zoom !== 1 }]),
              ref: "svgContainerMap",
              onMousedown: $setup.startDrag,
              onMousemove: $setup.handleDrag,
              onMouseup: $setup.stopDrag,
              onMouseleave: $setup.stopDrag,
              onWheel: $setup.handleWheel,
              onClickCapture: $setup.suppressClickAfterDrag
            }, [
              _createElementVNode("div", {
                class: "svg-layers",
                style: _normalizeStyle($setup.getSvgLayersStyle($setup.liveZoom)),
                ref: "svgLayers"
              }, [
                ($setup.masterplan && $setup.overlayViewBox && $setup.svgContent)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["svg-unified", { 'lot-matching-active': $setup.currentSidebarView === 'lot-matching' }])
                    }, [
                      _createElementVNode("div", {
                        class: "svg-background-content",
                        innerHTML: $setup.processedSvgForBackground
                      }, null, 8, _hoisted_18),
                      (_openBlock(), _createElementBlock("svg", {
                        class: "svg-interactive-overlay",
                        viewBox: $setup.overlayViewBox,
                        preserveAspectRatio: "xMidYMid meet",
                        style: _normalizeStyle({ '--overlay-stroke-w': $setup.overlayStrokeWidth })
                      }, [
                        ($setup.shouldRenderEstateBoundary)
                          ? (_openBlock(), _createElementBlock("g", {
                              key: 0,
                              class: _normalizeClass(["estate-boundary-group", { 'map-layer-hidden': $setup.showStages }]),
                              onClick: _withModifiers($setup.handleEstateBoundaryClick, ["stop"])
                            }, [
                              _createElementVNode("path", {
                                class: "estate-boundary-path",
                                d: $setup.masterplan.estateBoundaryPath,
                                style: _normalizeStyle({ fill: `rgba(140, 145, 150, ${$setup.masterplan.estateLabelMetadata?.boundaryOpacity ?? 0.55})` })
                              }, null, 12, _hoisted_20),
                              ($setup.estateBoundaryCentroid && ($setup.estateLabelDisplayText || $setup.masterplan.estateLabelMetadata?.logoUrl))
                                ? (_openBlock(), _createElementBlock("g", {
                                    key: 0,
                                    class: "estate-label-group",
                                    transform: $setup.estateLabelTransform
                                  }, [
                                    ($setup.masterplan.estateLabelMetadata?.logoUrl)
                                      ? (_openBlock(), _createElementBlock("image", {
                                          key: 0,
                                          class: "estate-label-logo",
                                          x: $setup.estateBoundaryCentroid.x + ($setup.masterplan.estateLabelMetadata?.offsetX || 0) - $setup.estateLabelLogoWidth / 2,
                                          y: $setup.estateBoundaryCentroid.y + ($setup.masterplan.estateLabelMetadata?.offsetY || 0) - $setup.estateLabelLogoHeight / 2,
                                          width: $setup.estateLabelLogoWidth,
                                          height: $setup.estateLabelLogoHeight,
                                          href: $setup.masterplan.estateLabelMetadata.logoUrl,
                                          preserveAspectRatio: "xMidYMid meet"
                                        }, null, 8, _hoisted_22))
                                      : ($setup.estateLabelDisplayText)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            ($setup.labelBboxes['estate'])
                                              ? (_openBlock(), _createElementBlock("rect", _mergeProps({
                                                  key: 0,
                                                  class: "estate-label-bg"
                                                }, $setup.getLabelRectAttrs('estate')), null, 16))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("text", {
                                              class: "estate-label",
                                              ref: (el) => { if (el) { $setup.labelTextRefs['estate'] = el as SVGTextElement; if (!$setup.labelBboxes['estate']) $setup.measureLabelBboxes(); } else { delete $setup.labelTextRefs['estate']; } },
                                              x: $setup.estateBoundaryCentroid.x + ($setup.masterplan.estateLabelMetadata?.offsetX || 0),
                                              y: $setup.estateBoundaryCentroid.y + ($setup.masterplan.estateLabelMetadata?.offsetY || 0),
                                              "font-size": $setup.lotNumberFontSize * 3,
                                              "text-anchor": "middle",
                                              "dominant-baseline": "middle"
                                            }, _toDisplayString($setup.estateLabelDisplayText), 9, _hoisted_23)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                  ], 8, _hoisted_21))
                                : _createCommentVNode("", true)
                            ], 2))
                          : _createCommentVNode("", true),
                        ($setup.shouldRenderStageLayer)
                          ? (_openBlock(), _createElementBlock("g", {
                              key: 1,
                              class: _normalizeClass(["stage-layer", { 'map-layer-hidden': !$setup.showStages || $setup.showLots }])
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.masterplanStages, (stageMeta) => {
                                return (_openBlock(), _createElementBlock("g", {
                                  class: _normalizeClass(["stage-group", { 'stage-not-selectable': !$setup.isStageNowSelling(stageMeta) }]),
                                  key: stageMeta.stageId,
                                  style: _normalizeStyle($setup.getStageGroupStyle(stageMeta.stageId)),
                                  onClick: _withModifiers(($event: any) => ($setup.isStageNowSelling(stageMeta) && $setup.handleStageClick(stageMeta, false)), ["stop"])
                                }, [
                                  _createElementVNode("path", {
                                    class: _normalizeClass(["stage-path", $setup.getStageClasses(stageMeta.stageId)]),
                                    d: stageMeta.boundaryPath,
                                    style: _normalizeStyle($setup.getStageFillStyle(stageMeta.stageId))
                                  }, null, 14, _hoisted_25),
                                  ($setup.getStageCentroid(stageMeta) && $setup.shouldShowStageLabel(stageMeta))
                                    ? (_openBlock(), _createElementBlock("g", {
                                        key: 0,
                                        class: "stage-label-group",
                                        transform: $setup.getStageLabelTransform(stageMeta)
                                      }, [
                                        ($setup.labelBboxes[$setup.getStageLabelKey(stageMeta)])
                                          ? (_openBlock(), _createElementBlock("rect", _mergeProps({
                                              key: 0,
                                              class: "stage-label-bg"
                                            }, { ref_for: true }, $setup.getLabelRectAttrs($setup.getStageLabelKey(stageMeta))), null, 16))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("text", {
                                          class: "stage-label",
                                          ref_for: true,
                                          ref: (el) => { const k = $setup.getStageLabelKey(stageMeta); if (el) { $setup.labelTextRefs[k] = el as SVGTextElement; if (!$setup.labelBboxes[k]) $setup.measureLabelBboxes(); } else { delete $setup.labelTextRefs[k]; } },
                                          x: $setup.getStageLabelCenterX(stageMeta),
                                          y: $setup.getStageLabelCenterY(stageMeta),
                                          "font-size": $setup.lotNumberFontSize * 2,
                                          "text-anchor": "middle",
                                          "dominant-baseline": "middle"
                                        }, "Stage " + _toDisplayString($setup.getStageName(stageMeta.stageId)), 9, _hoisted_27)
                                      ], 8, _hoisted_26))
                                    : _createCommentVNode("", true)
                                ], 14, _hoisted_24))
                              }), 128))
                            ], 2))
                          : _createCommentVNode("", true),
                        ($setup.shouldRenderSelectedStageLayer)
                          ? (_openBlock(), _createElementBlock("g", {
                              key: 2,
                              class: _normalizeClass(["selected-stage-layer", { 'map-layer-hidden': !$setup.showLots || !$setup.selectedStageMeta }])
                            }, [
                              ($setup.selectedStageMeta)
                                ? (_openBlock(), _createElementBlock("g", {
                                    class: "stage-group",
                                    key: $setup.selectedStageMeta.stageId
                                  }, [
                                    _createElementVNode("path", {
                                      class: "stage-path stage-selected",
                                      d: $setup.selectedStageMeta.boundaryPath,
                                      style: _normalizeStyle($setup.getStageFillStyle($setup.selectedStageMeta.stageId))
                                    }, null, 12, _hoisted_28)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          : _createCommentVNode("", true),
                        ($setup.shouldRenderLotsLayer)
                          ? (_openBlock(), _createElementBlock("g", {
                              key: 3,
                              class: _normalizeClass(["lots-shapes-layer", { 'map-layer-hidden': !$setup.showLots }])
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.masterplan.lots, (lot) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: lot._id
                                }, [
                                  (lot.shapePath)
                                    ? _withDirectives((_openBlock(), _createElementBlock("path", {
                                        key: 0,
                                        class: _normalizeClass(["lot-rect", $setup.getLotClasses(lot)]),
                                        d: lot.shapePath,
                                        onClick: ($event: any) => ($setup.handleMapLotClick(lot)),
                                        onMouseover: ($event: any) => ($setup.onLotHover(true, lot.lotId?._id)),
                                        onMouseleave: ($event: any) => ($setup.onLotHover(false, lot.lotId?._id))
                                      }, null, 42, _hoisted_29)), [
                                        [_directive_tippy, { content: $setup.getLotTooltip(lot), allowHTML: true, theme: 'map-tippy', appendTo: 'parent', arrow: false }]
                                      ])
                                    : (lot.polygonPoints && lot.polygonPoints.length)
                                      ? _withDirectives((_openBlock(), _createElementBlock("polygon", {
                                          key: 1,
                                          class: _normalizeClass(["lot-rect", $setup.getLotClasses(lot)]),
                                          points: $setup.getLotPolygonPoints(lot),
                                          onClick: ($event: any) => ($setup.handleMapLotClick(lot)),
                                          onMouseover: ($event: any) => ($setup.onLotHover(true, lot.lotId?._id)),
                                          onMouseleave: ($event: any) => ($setup.onLotHover(false, lot.lotId?._id))
                                        }, null, 42, _hoisted_30)), [
                                          [_directive_tippy, { content: $setup.getLotTooltip(lot), allowHTML: true, theme: 'map-tippy', appendTo: 'parent', arrow: false }]
                                        ])
                                      : (lot.boundingBox)
                                        ? _withDirectives((_openBlock(), _createElementBlock("rect", {
                                            key: 2,
                                            class: _normalizeClass(["lot-rect", $setup.getLotClasses(lot)]),
                                            x: lot.boundingBox.x,
                                            y: lot.boundingBox.y,
                                            width: lot.boundingBox.width,
                                            height: lot.boundingBox.height,
                                            onClick: ($event: any) => ($setup.handleMapLotClick(lot)),
                                            onMouseover: ($event: any) => ($setup.onLotHover(true, lot.lotId?._id)),
                                            onMouseleave: ($event: any) => ($setup.onLotHover(false, lot.lotId?._id))
                                          }, null, 42, _hoisted_31)), [
                                            [_directive_tippy, { content: $setup.getLotTooltip(lot), allowHTML: true, theme: 'map-tippy', appendTo: 'parent', arrow: false }]
                                          ])
                                        : _createCommentVNode("", true),
                                  (lot.statusBarPath)
                                    ? (_openBlock(), _createElementBlock("path", {
                                        key: 3,
                                        class: _normalizeClass(["lot-status-bar", $setup.getLotClasses(lot)]),
                                        d: lot.statusBarPath,
                                        "pointer-events": "none"
                                      }, null, 10, _hoisted_32))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ], 2))
                          : _createCommentVNode("", true),
                        ($setup.shouldRenderLotsLayer)
                          ? (_openBlock(), _createElementBlock("g", {
                              key: 4,
                              class: _normalizeClass(["lot-numbers-layer", { 'map-layer-hidden': !$setup.showLots }])
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.masterplan.lots, (lot) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: 'lot-num-' + lot._id
                                }, [
                                  ($setup.shouldShowLotNumber(lot))
                                    ? (_openBlock(), _createElementBlock("text", {
                                        key: 0,
                                        class: _normalizeClass(["lot-number", $setup.getLotClasses(lot)]),
                                        x: $setup.getLotNumberCenterX(lot),
                                        y: $setup.getLotNumberCenterY(lot),
                                        transform: $setup.getLotNumberTransform(lot),
                                        "text-anchor": "middle",
                                        "dominant-baseline": "middle",
                                        "font-size": $setup.LOT_NUMBER_FONT_SIZE,
                                        onClick: _withModifiers(($event: any) => ($setup.handleMapLotClick(lot)), ["stop"]),
                                        onMouseover: ($event: any) => ($setup.onLotHover(true, lot.lotId?._id)),
                                        onMouseleave: ($event: any) => ($setup.onLotHover(false, lot.lotId?._id))
                                      }, _toDisplayString(lot.lotId?.title), 43, _hoisted_33))
                                    : _createCommentVNode("", true),
                                  ($setup.shouldShowLotSize(lot))
                                    ? (_openBlock(), _createElementBlock("text", {
                                        key: 1,
                                        class: _normalizeClass(["lot-size", $setup.getLotClasses(lot)]),
                                        x: $setup.getLotSizeCenterX(lot),
                                        y: $setup.getLotSizeCenterY(lot),
                                        transform: $setup.getLotSizeTransform(lot),
                                        "text-anchor": "middle",
                                        "dominant-baseline": "middle",
                                        "font-size": $setup.LOT_SIZE_FONT_SIZE,
                                        onClick: _withModifiers(($event: any) => ($setup.handleMapLotClick(lot)), ["stop"]),
                                        onMouseover: ($event: any) => ($setup.onLotHover(true, lot.lotId?._id)),
                                        onMouseleave: ($event: any) => ($setup.onLotHover(false, lot.lotId?._id))
                                      }, _toDisplayString($setup.formatLotSize(lot.lotId?.size)), 43, _hoisted_34))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ], 2))
                          : _createCommentVNode("", true),
                        ($setup.shouldRenderPoiLayer)
                          ? (_openBlock(), _createElementBlock("g", {
                              key: 5,
                              class: _normalizeClass(["poi-layer", { 'map-layer-hidden': !$setup.showStages }])
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.masterplan.pointsOfInterest, (poi, idx) => {
                                return (_openBlock(), _createElementBlock("g", {
                                  class: "poi-group",
                                  key: 'poi-' + idx,
                                  onClick: _withModifiers(($event: any) => ($setup.handlePoiClick(poi)), ["stop"])
                                }, [
                                  _createElementVNode("rect", {
                                    class: "poi-hit",
                                    x: poi.boundingBox.x,
                                    y: poi.boundingBox.y,
                                    width: poi.boundingBox.width,
                                    height: poi.boundingBox.height,
                                    fill: "transparent",
                                    stroke: "none"
                                  }, null, 8, _hoisted_36),
                                  _createElementVNode("g", {
                                    class: "poi-marker",
                                    transform: `translate(${poi.boundingBox.x + poi.boundingBox.width / 2}, ${poi.boundingBox.y + poi.boundingBox.height / 2})`
                                  }, [
                                    _createElementVNode("g", {
                                      class: "poi-pin-icon",
                                      transform: `translate(${-$setup.getPoiPinSize(poi) / 2}, ${-$setup.getPoiPinSize(poi) / 2}) scale(${$setup.getPoiPinSize(poi) / 24})`
                                    }, [...(_cache[19] || (_cache[19] = [
                                      _createElementVNode("path", {
                                        class: "poi-pin-outer",
                                        d: "M20 10c0 6-8 13-8 13s-8-7-8-13a8 8 0 0 1 16 0Z"
                                      }, null, -1),
                                      _createElementVNode("circle", {
                                        class: "poi-pin-inner",
                                        cx: "12",
                                        cy: "10",
                                        r: "2.5"
                                      }, null, -1)
                                    ]))], 8, _hoisted_38),
                                    _createElementVNode("text", {
                                      class: "poi-label",
                                      "text-anchor": "middle",
                                      "dominant-baseline": "hanging",
                                      y: $setup.getPoiPinSize(poi) / 2 + 4,
                                      "font-size": $setup.poiLabelFontSize
                                    }, _toDisplayString(poi.title), 9, _hoisted_39)
                                  ], 8, _hoisted_37)
                                ], 8, _hoisted_35))
                              }), 128))
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 12, _hoisted_19))
                    ], 2))
                  : _createCommentVNode("", true)
              ], 4)
            ], 34)
          ], 2)
        ], 4),
        ($setup.masterplan)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["map-side-panel-container", { 'map-side-panel-container--land-subdivision': $setup.isLandSubdivisionBuyerView }])
            }, [
              ($setup.lotsLoading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "skeleton-header" }, [
                      _createElementVNode("div", { class: "skeleton-line w55" }),
                      _createElementVNode("div", { class: "skeleton-line thin w35" })
                    ], -1)),
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "skeleton-divider" }, null, -1)),
                    _createElementVNode("div", _hoisted_40, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                        return _createElementVNode("div", {
                          class: "skeleton-card",
                          key: i
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["skeleton-line", 'w' + [70, 55, 80, 65, 75][i-1]])
                          }, null, 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["skeleton-line thin", 'w' + [40, 35, 50, 38, 45][i-1]])
                          }, null, 2)
                        ])
                      }), 64))
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    ($setup.currentSidebarView === 'stages')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "lots-panel-header" }, [
                            _createElementVNode("h5", { class: "side-panel-title bold" }, "Available Lots"),
                            _createElementVNode("p", { class: "side-panel-subtitle" }, "Select a stage to browse lots on the map.")
                          ], -1)),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stagesWithCounts, (stage) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "stage-card",
                                  key: stage._id,
                                  onClick: ($event: any) => ($setup.selectStage(stage))
                                }, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("h5", _hoisted_46, "Stage " + _toDisplayString(stage.title), 1),
                                    _createElementVNode("p", _hoisted_47, _toDisplayString(stage.totalLots) + " Lots · " + _toDisplayString(stage.availableLots) + " Available", 1)
                                  ]),
                                  _createVNode($setup["ChevronRight"], {
                                    class: "stage-chevron",
                                    size: 24
                                  })
                                ], 8, _hoisted_44))
                              }), 128)),
                              ($setup.stagesWithCounts.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [...(_cache[22] || (_cache[22] = [
                                    _createElementVNode("div", { class: "no-lots-info" }, "No stages available", -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    ($setup.currentSidebarView === 'lots' && $setup.selectedStage)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["lots-panel-header", { 'lots-panel-header--land-subdivision': $setup.isLandSubdivisionBuyerView }])
                          }, [
                            _createElementVNode("div", {
                              class: "back-button",
                              onClick: $setup.backToStages
                            }, [...(_cache[24] || (_cache[24] = [
                              _createElementVNode("img", {
                                class: "back-icon",
                                src: _imports_0,
                                alt: "Back"
                              }, null, -1),
                              _createElementVNode("span", null, "All Stages", -1)
                            ]))]),
                            _createElementVNode("h5", _hoisted_49, "Stage " + _toDisplayString($setup.selectedStage.title), 1),
                            _createElementVNode("p", _hoisted_50, _toDisplayString($setup.selectedStageLotsCount) + " Lots · " + _toDisplayString($setup.selectedStageAvailableCount) + " Available", 1),
                            ($setup.hasLandSubdivisionPackagesFeature)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_51, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.showPackagesOnly) = $event))
                                  }, null, 512), [
                                    [_vModelCheckbox, $setup.showPackagesOnly]
                                  ]),
                                  _cache[25] || (_cache[25] = _createElementVNode("span", null, "Show Home & Land Packages Only", -1))
                                ]))
                              : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["lots-list", { 'lots-list--land-subdivision': $setup.isLandSubdivisionBuyerView }])
                            }, [
                              ($setup.isLandSubdivisionBuyerView)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.displayedLandSubdivisionLots, (lot) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["land-subdivision-lot-card", { 'land-subdivision-lot-card--hovered': $setup.hoverLotId === lot.lotId?._id, 'land-subdivision-lot-card--selected': $setup.selectedLotId === lot.lotId?._id }]),
                                      key: lot.lotId?._id || lot.svgElementId,
                                      onMouseover: ($event: any) => ($setup.onLotHover(true, lot.lotId?._id)),
                                      onMouseleave: ($event: any) => ($setup.onLotHover(false, lot.lotId?._id)),
                                      onClick: ($event: any) => ($setup.handleSidebarLotClick(lot))
                                    }, [
                                      _createElementVNode("div", _hoisted_54, [
                                        _createElementVNode("div", _hoisted_55, [
                                          _createElementVNode("h5", null, "Lot " + _toDisplayString(lot.lotId?.title), 1),
                                          _createElementVNode("div", {
                                            class: "lot-status-badge",
                                            style: _normalizeStyle($setup.getMasterplanStatusBadgeStyle(lot.lotId?.status))
                                          }, _toDisplayString($setup.getMasterplanLotStatusLabel(lot.lotId?.status)), 5)
                                        ]),
                                        _createElementVNode("div", _hoisted_56, [
                                          _createElementVNode("div", _hoisted_57, [
                                            _cache[26] || (_cache[26] = _createElementVNode("span", { class: "detail-label" }, "Area", -1)),
                                            _createElementVNode("span", _hoisted_58, _toDisplayString(lot.lotId?.size ? `${lot.lotId.size}m²` : "--"), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_59, [
                                            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "detail-label" }, "Width", -1)),
                                            _createElementVNode("span", _hoisted_60, _toDisplayString(lot.lotId?.blockWidth ? `${lot.lotId.blockWidth}m` : "--"), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_61, [
                                            _cache[28] || (_cache[28] = _createElementVNode("span", { class: "detail-label" }, "Price", -1)),
                                            _createElementVNode("span", _hoisted_62, _toDisplayString($setup.getLandSubdivisionLotPrice(lot)), 1)
                                          ])
                                        ])
                                      ]),
                                      ($setup.getLotPackageCount(lot) > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                            _createVNode($setup["Home"], { size: 18 }),
                                            _createElementVNode("span", null, _toDisplayString($setup.getLotPackageAvailabilityLabel(lot)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_64, [
                                        _createElementVNode("button", {
                                          class: "land-subdivision-lot-card__action-btn",
                                          type: "button",
                                          onClick: _withModifiers(($event: any) => ($setup.viewSidebarLotOnMap(lot)), ["stop"])
                                        }, [
                                          _createVNode($setup["MapIcon"], { size: 16 }),
                                          _cache[29] || (_cache[29] = _createElementVNode("span", null, "View on Map", -1))
                                        ], 8, _hoisted_65),
                                        _createElementVNode("button", {
                                          class: "land-subdivision-lot-card__action-btn",
                                          type: "button",
                                          onClick: _withModifiers(($event: any) => ($setup.openSidebarLotDetails(lot)), ["stop"])
                                        }, [
                                          _createVNode($setup["Info"], { size: 16 }),
                                          _cache[30] || (_cache[30] = _createElementVNode("span", null, "Lot Details", -1))
                                        ], 8, _hoisted_66)
                                      ])
                                    ], 42, _hoisted_53))
                                  }), 128))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.availableLotsForSelectedStage, (lot) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["lot-card", { 'lot-card-hovered': $setup.hoverLotId === lot.lotId?._id, 'lot-card-selected': $setup.selectedLotId === lot.lotId?._id }]),
                                      key: lot.lotId?._id || lot.svgElementId,
                                      onMouseover: ($event: any) => ($setup.onLotHover(true, lot.lotId?._id)),
                                      onMouseleave: ($event: any) => ($setup.onLotHover(false, lot.lotId?._id)),
                                      onClick: ($event: any) => ($setup.handleSidebarLotClick(lot))
                                    }, [
                                      _createElementVNode("div", _hoisted_68, [
                                        _createElementVNode("div", _hoisted_69, [
                                          _createElementVNode("h5", _hoisted_70, "Lot " + _toDisplayString(lot.lotId?.title), 1),
                                          _createElementVNode("div", {
                                            class: "lot-status-badge",
                                            style: _normalizeStyle($setup.getMasterplanStatusBadgeStyle(lot.lotId?.status))
                                          }, _toDisplayString($setup.getMasterplanLotStatusLabel(lot.lotId?.status)), 5)
                                        ]),
                                        ($setup.getLotDesignLabel(lot) || $setup.getLotFacadeLabel(lot))
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_71, [
                                              ($setup.getLotDesignLabel(lot))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_72, _toDisplayString($setup.getLotDesignLabel(lot)), 1))
                                                : _createCommentVNode("", true),
                                              ($setup.getLotDesignLabel(lot) && $setup.getLotFacadeLabel(lot))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_73, " · "))
                                                : _createCommentVNode("", true),
                                              ($setup.getLotFacadeLabel(lot))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString($setup.getLotFacadeLabel(lot)), 1))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_75, [
                                          _createElementVNode("div", _hoisted_76, [
                                            (lot.lotId?.size)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_77, [
                                                  _createVNode($setup["Maximize2"], {
                                                    class: "lot-detail-icon",
                                                    size: 14
                                                  }),
                                                  _createElementVNode("span", null, _toDisplayString(lot.lotId.size) + "m²", 1)
                                                ]))
                                              : _createCommentVNode("", true),
                                            (lot.lotId?.blockWidth)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_78, [
                                                  _createVNode($setup["MoveHorizontal"], {
                                                    class: "lot-detail-icon",
                                                    size: 14
                                                  }),
                                                  _createElementVNode("span", null, _toDisplayString(lot.lotId.blockWidth) + "m", 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          ($setup.getLotPackagePrice(lot) && !lot.lotId?.hidePrice)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_79, [
                                                _createElementVNode("span", null, _toDisplayString($setup.formatPrice($setup.getLotPackagePrice(lot))), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_80, [
                                        ($setup.getLotAssignedFacadeUrl(lot))
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: $setup.getLotAssignedFacadeUrl(lot),
                                              alt: 'Lot ' + lot.lotId?.title
                                            }, null, 8, _hoisted_81))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                              _createVNode($setup["Home"], { size: 24 })
                                            ]))
                                      ]),
                                      _createElementVNode("div", _hoisted_83, [
                                        _createElementVNode("button", {
                                          class: "lot-card-action-btn",
                                          type: "button",
                                          onClick: _withModifiers(($event: any) => ($setup.viewSidebarLotOnMap(lot)), ["stop"])
                                        }, [
                                          _createVNode($setup["MapIcon"], { size: 16 }),
                                          _cache[31] || (_cache[31] = _createElementVNode("span", null, "View on Map", -1))
                                        ], 8, _hoisted_84),
                                        _createElementVNode("button", {
                                          class: "lot-card-action-btn",
                                          type: "button",
                                          onClick: _withModifiers(($event: any) => ($setup.openSidebarLotDetails(lot)), ["stop"])
                                        }, [
                                          _createVNode($setup["Info"], { size: 16 }),
                                          _cache[32] || (_cache[32] = _createElementVNode("span", null, "Lot Details", -1))
                                        ], 8, _hoisted_85)
                                      ])
                                    ], 42, _hoisted_67))
                                  }), 128)),
                              ($setup.isLandSubdivisionBuyerView ? $setup.displayedLandSubdivisionLots.length === 0 : $setup.availableLotsForSelectedStage.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_86, [...(_cache[33] || (_cache[33] = [
                                    _createElementVNode("div", { class: "no-lots-info" }, "No lots found for this stage", -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    ($setup.currentSidebarView === 'lot-matching')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", {
                              class: "back-button",
                              onClick: $setup.goBackFromMatching
                            }, [...(_cache[34] || (_cache[34] = [
                              _createElementVNode("img", {
                                class: "back-icon",
                                src: _imports_0,
                                alt: "Back"
                              }, null, -1),
                              _createElementVNode("span", null, "All Lots", -1)
                            ]))]),
                            _createElementVNode("div", _hoisted_88, [
                              _createElementVNode("div", _hoisted_89, [
                                _createElementVNode("div", _hoisted_90, [
                                  _cache[35] || (_cache[35] = _createElementVNode("p", { class: "selection-eyebrow" }, "Your Selection", -1)),
                                  _createElementVNode("h4", _hoisted_91, _toDisplayString($setup.matchingHouseDesignInfo?.name), 1),
                                  ($setup.matchingFacadeName)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_92, "Facade: " + _toDisplayString($setup.matchingFacadeName), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("p", _hoisted_93, "From " + _toDisplayString($setup.formatPrice($setup.matchingHouseDesignInfo?.basePrice ?? 0)), 1),
                                  _createElementVNode("div", _hoisted_94, [
                                    _createElementVNode("div", _hoisted_95, [
                                      _createVNode($setup["Bed"], {
                                        class: "spec-icon",
                                        size: 16
                                      }),
                                      _createElementVNode("span", null, _toDisplayString($setup.matchingHouseDesignInfo?.bedroom) + " Bed", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_96, [
                                      _createVNode($setup["Bath"], {
                                        class: "spec-icon",
                                        size: 16
                                      }),
                                      _createElementVNode("span", null, _toDisplayString($setup.matchingHouseDesignInfo?.bathroom?.quantity) + " Bath", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_97, [
                                      _createVNode($setup["Car"], {
                                        class: "spec-icon",
                                        size: 16
                                      }),
                                      _createElementVNode("span", null, _toDisplayString($setup.matchingHouseDesignInfo?.garage) + " Car", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_98, [
                                      _createVNode($setup["Maximize2"], {
                                        class: "spec-icon",
                                        size: 16
                                      }),
                                      _createElementVNode("span", null, _toDisplayString($setup.matchingHouseDesignInfo?.area) + " m²", 1)
                                    ])
                                  ]),
                                  _createElementVNode("button", {
                                    class: "change-design-btn",
                                    onClick: $setup.changeDesign
                                  }, "Change Design")
                                ]),
                                ($setup.matchingHouseDesignInfo?.floorplans?.[0]?.url)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      class: "selection-floorplan",
                                      src: $setup.matchingHouseDesignInfo.floorplans[0].url,
                                      alt: "Floorplan"
                                    }, null, 8, _hoisted_99))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("h5", _hoisted_100, _toDisplayString($setup.lotsForMatchingDesign.length) + " Compatible Lots", 1)
                          ]),
                          _createElementVNode("div", _hoisted_101, [
                            _createElementVNode("div", _hoisted_102, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lotsForMatchingDesign, (lot) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass(["lot-card", { 'lot-card-hovered': $setup.hoverLotId === lot.lotId?._id }]),
                                  key: lot.lotId?._id || lot.svgElementId,
                                  onMouseover: ($event: any) => ($setup.onLotHover(true, lot.lotId?._id)),
                                  onMouseleave: ($event: any) => ($setup.onLotHover(false, lot.lotId?._id)),
                                  onClick: ($event: any) => ($setup.handleMatchingLotClick(lot))
                                }, [
                                  _createElementVNode("div", _hoisted_104, [
                                    _createElementVNode("div", _hoisted_105, [
                                      _createElementVNode("h5", _hoisted_106, "Lot " + _toDisplayString(lot.lotId?.title), 1),
                                      _createElementVNode("div", {
                                        class: "lot-status-badge",
                                        style: _normalizeStyle($setup.getMasterplanStatusBadgeStyle(lot.lotId?.status))
                                      }, _toDisplayString($setup.getMasterplanLotStatusLabel(lot.lotId?.status)), 5)
                                    ]),
                                    ($setup.getLotFacadeLabel(lot, $props.matchingHouseDesignId))
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_107, _toDisplayString($setup.getLotFacadeLabel(lot, $props.matchingHouseDesignId)), 1))
                                      : _createCommentVNode("", true),
                                    ($setup.getStageName(lot.lotId?.stageId))
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_108, "Stage " + _toDisplayString($setup.getStageName(lot.lotId?.stageId)), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_109, [
                                      _createElementVNode("div", _hoisted_110, [
                                        (lot.lotId?.size)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_111, [
                                              _createVNode($setup["Maximize2"], {
                                                class: "lot-detail-icon",
                                                size: 14
                                              }),
                                              _createElementVNode("span", null, _toDisplayString(lot.lotId.size) + "m²", 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (lot.lotId?.blockWidth)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_112, [
                                              _createVNode($setup["MoveHorizontal"], {
                                                class: "lot-detail-icon",
                                                size: 14
                                              }),
                                              _createElementVNode("span", null, _toDisplayString(lot.lotId.blockWidth) + "m", 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      ($setup.getLotPackagePrice(lot, $props.matchingHouseDesignId) && !lot.lotId?.hidePrice)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_113, [
                                            _createElementVNode("span", null, _toDisplayString($setup.formatPrice($setup.getLotPackagePrice(lot, $props.matchingHouseDesignId))), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_114, [
                                    ($setup.getLotAssignedFacadeUrl(lot, $props.matchingHouseDesignId))
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: $setup.getLotAssignedFacadeUrl(lot, $props.matchingHouseDesignId),
                                          alt: 'Lot ' + lot.lotId?.title
                                        }, null, 8, _hoisted_115))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                          _createVNode($setup["Home"], { size: 24 })
                                        ]))
                                  ])
                                ], 42, _hoisted_103))
                              }), 128)),
                              ($setup.lotsForMatchingDesign.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_117, [...(_cache[36] || (_cache[36] = [
                                    _createElementVNode("div", { class: "no-lots-info" }, "No compatible lots found for this design", -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
            ], 2))
          : _createCommentVNode("", true)
      ], 2)
    ], 2)
  ], 2))
}